$(document).ready(function(){
  // $('html,body').animate({ scrollTop: 0 }, '1');
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  var windowWidth = $(window).width();
  var titleWidth = $('.title').width();
  var titlePosX = $('.title').offset().left;
  var titlePosY = $('.title').offset().top;
  $('.title').css('transform','translate('+(((windowWidth-titleWidth)/2-titlePosX))+'px,'+(((windowHeight-titleHeight)/2-titlePosY))+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','600ms');
    $('.title').addClass('active2');
    $('.overlay_white').fadeOut(1000);
  },1600);
  setTimeout(function(){
    $('.title').css('z-index','3');
  },2200);
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  var scrollStart = 0;
  $(window).on('scroll', function(){
    if($(this).scrollTop() > scrollStart ){
      modalclose();
    }
    scrollStart = $(this).scrollTop();
  });

  var mainSwiper = new Swiper('#slider', {
    // パラメーター
    loop: true,
    slidesPerView: 4,
    speed:6000,
    allowTouchMove: false,
    autoplay: {delay: 0},
    breakpoints: {
      768: {
        spaceBetween:20,
        slidesPerView: 2,
      }
    }
  });

  $('.mv_item').click(function(){
      var This = $(this);
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      var headerHeight = $('header').height();
      var contentHeight = windowHeight - headerHeight;
      var zoomRatio = This.data("zoom");
      var itemWidth = This.width();
      var itemHeight = This.find('.mv_modal_img').height();
      var itemPosX = This.offset().left;
      var itemPosY = This.offset().top;
      var textHeight = This.find('.mv_item_text').height();
      var whRatio = windowWidth / windowHeight;
      if (whRatio > 1.35) {
        var zoomRatio = zoomRatio * 1.2 / whRatio;
      }
      var movePosX = (windowWidth - (itemWidth * zoomRatio)) / 2;
      var movePosY = (contentHeight - (itemHeight * zoomRatio) - textHeight) / 2 + headerHeight;
      var moveX = movePosX - itemPosX;
      var moveY = movePosY - itemPosY;
      var sizeRatio = itemHeight / itemWidth;
      var movePosY2 = (windowHeight - (windowWidth * 0.8 * sizeRatio) - textHeight) / 2;
      var moveY2 = movePosY2 - itemPosY;
      var modalContent = This.find('.mv_item_main').html();
    if (This.hasClass('zoom')) {
      $('.mv_wrapper').removeClass('active');
      $("html, body").css('overflow','auto');
      This.removeClass('zoom');
      This.find('.mv_item_main').css('width','100%');
      This.css('transform','translate(0,0)');
      $('.mv_modal_bg').remove();
      setTimeout(function(){
        This.removeClass('inner_zoom');
        This.removeClass('clip');
      },200);
    }else{
      $("html, body").animate({scrollTop:0}, 400, "swing");
      $("html, body").css('overflow','hidden');
      if ($('.pc_only').css('display')=='none') {
        $('body').append('<div class="mv_modal_box">'+modalContent+'</div>');
        if (This.hasClass('mv_item1')) {
          $('.mv_modal_box').addClass('width80');
        }
      }else{
        if (This.hasClass('mv_item1')) {
          $('.mv_wrapper').addClass('active');
        }
        This.addClass('zoom');
        This.addClass('inner_zoom');
        This.css('transform','translate('+moveX+'px,'+moveY+'px)');
        This.find('.mv_item_main').css('width',(itemWidth * zoomRatio));
        This.css('transform','translate('+moveX+'px,'+moveY+'px)');
        This.addClass('clip');
      }
      $('body').append('<div class="mv_modal_bg"></div>');
    }
    $('.mv_modal_bg,.mv_modal_box,.detail_btn a').click(function(){
      modalclose();
    });
  });

  function modalclose(){
    $('.mv_wrapper').removeClass('active');
    $("html, body").css('overflow','auto');
    $('.mv_item').removeClass('zoom');
    $('.mv_item_main').css('width','100%');
    $('.mv_item').css('transform','translate(0,0)');
    $('.mv_modal_bg').remove();
    $('.mv_modal_box').remove();
    setTimeout(function(){
      $('.mv_item').removeClass('inner_zoom');
      $('.mv_item').removeClass('clip');
    },200);
  };

  var windowSizeW = $(window).innerWidth();

  $(window).on('resize',function(){
    if (windowSizeW != $(window).innerWidth()) {
      modalclose();
    }
    $('.mv_modal_box').css('top','50%');
  });




  // modal
  $(function(){
    $('.swiper-slide').click(function(){
      var modalImg = $(this).html();
      $('body').append('<div class="modal_bg flex flex_middle flex_center"><div class="modal_img">'+modalImg+'</div></div>');
      $('body').css('overflow','hidden');

      $('.modal_bg').click(function(){
        $(this).remove();
        $('body').css('overflow','auto');
      });
    });
  });


// SP MENU
  $('.sp_menu_line').click(function(){
    $('.header_menu').toggleClass('open');
    $('.header_open_overlay').toggle();
  });
  $('.sp_menu_inner ul li a').click(function(){
    $('.header_menu').removeClass('open');
    $('.header_open_overlay').toggle();
  });
  $('.header_open_overlay').click(function(){
    $('.header_menu').toggleClass('open');
    $(this).toggle();
  });

});
